/*
 * @Author: 'chenmengni'
 * @Date: 2025-03-07 09:30:37
 * @LastEditors: Tommy Chen weiyao_85@163.com
 * @LastEditTime: 2025-06-26 15:10:04
 * @FilePath: \help.center.intl\src\utils\query.js
 * @Description: 
 */
import $axios from '@/plugins/axios'
import { config } from '@/config'
/**
 *
 * @param {String} code 接口代码
 * @param {Object} data 接口参数
 * @returns {Promise<any>}
 */
// 海外
// const baseurl = "cloud-us.lysoratech.com/bida/faq/"
// const searchurl = "cloud-us.lysoratech.com/bida/open_search/search/faq"
// const replaceUrl = 'cloud-us.lysoratech.com/llmopsprod/'

// 国内
// 目录接口：https://cloud-us.lysoratech.com/llmopsprod/wiki-api/queryWikiForCloud/eedaddc158874da89f7d029b182b1c00
// 文章接口：https://cloud-us.lysoratech.com/llmopsprod/wiki/docsInfo/toReview?docId=29c2ce0ccf564a208fd350a19418a95e
// 搜索接口：https://cloud-us.lysoratech.com/llmopsprod/wiki-api/esForBida?wikiId=eedaddc158874da89f7d029b182b1c00&keyword=vpn
// 可以了
// 目录接口：https://cloud-us.lysoratech.com/llmopsprod/wiki-api/queryWikiForCloud/{目录id，目前固定eedaddc158874da89f7d029b182b1c00}
// 文章接口：https://cloud-us.lysoratech.com/llmopsprod/wiki/docsInfo/toReview?docId={文档id}
// 搜索接口：https://cloud-us.lysoratech.com/llmopsprod/wiki-api/esForBida?wikiId={目录id，固定见上面}&keyword={搜索关键字}

const baseurl = "https://cloud-us.lysoratech.com/bida/faq/"
const searchurl = "https://cloud-us.lysoratech.com/bida/open_search/search/faq"
const replaceUrl = 'https://cloud-us.lysoratech.com/llmopsprod/'



$axios.postRequest = (url, data, loading = false) => {
    let params = {
        ContentType: "application/json",
        params: JSON.stringify(data),
    };
    return Promise.resolve(/*  */
        $axios.post(url, params, {
            loading
        })
    )
}

$axios.getRequest = (url) => {
    return Promise.resolve(
        $axios.get(url)
    )
}

$axios.getParamRequest = (url,data) => {
    let opts = {
        ...data
    };
    return Promise.resolve(
        $axios.get(url,{...opts})
    )
}
//
// ISP的文档知识库ID：3f3e51881a56470b994afca594186987
// ISP更新说明：4ac8d553a7bb45c78bbf1adfd79f3ec1
// ISP快速指南：52720b1095db47ddb380f12abbf9e420
export function getIspCategories() {
    let url = replaceUrl + "wiki-api/queryWikiForCloud/eedaddc158874da89f7d029b182b1c00"
    return $axios.getRequest(url).catch(error => {
        console.error('Failed to fetch ISP categories:', error);
        throw error;
    });
}
export function getIspRelease() {
    let url = replaceUrl + "wiki-api/queryWikiForCloud/4ac8d553a7bb45c78bbf1adfd79f3ec1"
    return $axios.getRequest(url).catch(error => {
        console.error('Failed to fetch ISP release:', error);
        throw error;
    });
}

export function getIspQuickGuide() {
    let url = replaceUrl + "wiki-api/queryWikiForCloud/52720b1095db47ddb380f12abbf9e420"
    return $axios.getRequest(url).catch(error => {
        console.error('Failed to fetch ISP quick guide:', error);
        throw error;
    });
}
// 3、请求文章
export function queryIspArticleList(keyword) {
    let url = replaceUrl + "wiki-api/esForBida?wikiId=eedaddc158874da89f7d029b182b1c00&keyword=" + keyword
    let  headers = {
        headers: {
           'apiKey':'L8fJkqU7w5Q3n2X1Yb8Z9A=='
        }
    }
    return $axios.getParamRequest(url,headers).catch(error => {
        console.error('Failed to query ISP articles:', error);
        throw error;
    });
}

// 接口
// 0、请求文章内容的json的url
export function getJSON(url) {
    return $axios.getRequest(url).catch(error => {
        console.error('Failed to fetch JSON:', url, error);
        throw error;
    });
}
// 1、请求文章目录
// categories() 用于获取"用户指南"目录数据，目录ID为95
// 返回包含目录结构的JSON数据，用于构建导航菜单
export function categories() {
    let url = replaceUrl + "wiki-api/queryWikiForCloud/eedaddc158874da89f7d029b182b1c00"
    // let url = baseurl + "directories?id=95"
    return $axios.getRequest(url).catch(error => {
        console.error('Failed to fetch categories:', error);
        throw error;
    });
}

// 1、请求发布说明目录
// categories2() 用于获取“发布说明”目录数据，目录ID为94
export function categories2() {
    let url = baseurl + "directories?id=94"
    // let url = replaceUrl + "wiki-api/queryWikiForCloud/94"
    return $axios.getRequest(url).catch(error => {
        console.error('Failed to fetch categories2:', error);
        throw error;
    });
}

// categories3() 用于获取“快速上手”目录数据，目录ID为102
export function categories3() {
    let url = baseurl + "directories?id=102"
    // let url = replaceUrl + "wiki-api/queryWikiForCloud/102"
    return $axios.getRequest(url).catch(error => {
        console.error('Failed to fetch categories3:', error);
        throw error;
    });
}


// 2、请求文章
export function articles(id) {
    // let url = baseurl + "content?id=" + id
    let url = replaceUrl + "wiki/docsInfo/toReview?docId=" + id
    return $axios.getRequest(url).catch(error => {
        console.error('Failed to fetch article:', id, error);
        throw error;
    });
}
// 3、请求文章
export function queryArticleList(keyword) {
    let url = replaceUrl + "wiki-api/esForBida?wikiId=94,95&keyword=" + keyword
    let  headers = {
        headers: {
           'apiKey':'L8fJkqU7w5Q3n2X1Yb8Z9A=='
        }
    }
    return $axios.getParamRequest(url,headers).catch(error => {
        console.error('Failed to query articles:', error);
        throw error;
    });
}